// Клиент распознавания источников (текст/ссылка/скриншот) через сервер —
// сервер обращается к ИИ-провайдеру, ключ в браузер не попадает. Контракт
// авторитетно описан в SPEC.md (общий для трёх параллельных агентов);
// эндпоинты пишет другой агент — здесь только форма запроса/ответа.
import { request } from '../../auth/request';
import type { ApiResult } from '../../auth/request';
import type { Currency } from '../../types';

export type AiSource = 'text' | 'url' | 'screenshot';

/** Черновик рейса, как его вернул сервер. Таймзоны почти всегда '' —
 *  клиент дополняет их через lookupTz() (см. draftForm.ts). */
export interface AiDraft {
  from: string;
  to: string;
  fromTz: string;
  toTz: string;
  departLocal: string;
  arriveLocal: string;
  carrier: string;
  flightNumber: string;
  priceMinor: number | null;
  currency: Currency;
  missing: string[];
  notes: string[];
}

export interface RecognizeConfig {
  enabled: boolean;
  sources: { text: boolean; url: boolean; screenshot: boolean };
  models: { text: string; url: string; screenshot: string };
  maxImageBytes: number;
  /** Сколько скриншотов сервер примет за один запрос. */
  maxImages?: number;
  /** Суммарный вес пачки скриншотов. */
  maxTotalImageBytes?: number;
}

export interface RecognizeUsage {
  prompt: number;
  completion: number;
  total: number;
}

export interface RecognizeResult {
  ok: true;
  source: AiSource;
  model: string;
  drafts: AiDraft[];
  notes: string[];
  usage?: RecognizeUsage;
}

export interface RecognizeInput {
  source: AiSource;
  text?: string;
  url?: string;
  /** data:image/...;base64,… — уже подготовленные картинки (см. image.ts). */
  images?: string[];
}

/** Конфиг тянется один раз при открытии модала. 401 для гостя — штатный случай. */
export function fetchRecognizeConfig(signal?: AbortSignal): Promise<ApiResult<RecognizeConfig>> {
  return request<RecognizeConfig>('/api/recognize/config', { method: 'GET', signal });
}

/** Сам запрос на распознавание. Отменяемый через AbortSignal — повторный клик
 *  во время запроса не должен слать второй. */
export function recognize(input: RecognizeInput, signal?: AbortSignal): Promise<ApiResult<RecognizeResult>> {
  return request<RecognizeResult>('/api/recognize', { method: 'POST', json: input, signal });
}
